<template>
  <div ref="appRef" class="lowcode-root scroll" elementtiming="lc-pf-id">
    <ElConfigProvider :locale="lang">
      <router-view v-slot="{ Component, route }">
        <component :is="Component" v-bind="route.params"></component>
      </router-view>
    </ElConfigProvider>
  </div>
</template>

<script setup lang="ts">
import '@/assets/scss/app/index.scss';
// import { usePClientStore } from '@/store/modules/client';
// import { usePUserStore } from '@/store/modules/user';
// import { usePClientStore, usePUserStore } from '@/store';
import lang from 'element-plus/es/locale/lang/zh-cn';
import 'normalize.css/normalize.css';
import { onBeforeUnmount, ref } from 'vue';
// import { computed } from 'vue';
import { setTheme } from '@/utils';
import { bindThemeChange, unbindThemeChange, bindPageShow, unbindPageShow } from '@/utils/wps-fn';
import { getMyAppEmitter, MY_APP_EMITTER } from '@/features/my-app/my-app.tools';
// import { useRInitOnNotifyCommon } from './init-on-notify-common';

// import { WScroll } from '@vas2t-lowcode/libs';

const appRef = ref<HTMLElement>();

// /** 当前状态数据 */
// const userStore = usePUserStore();
// const clientStore = usePClientStore();
/** 是否可以渲染页面 */
// const isReady = computed(() => userStore.isReady);
// 获取是否引导
// clientStore.setGuide();
// 设置主题
setTheme();
bindThemeChange(setTheme);
bindPageShow((isShow) => {
  if (isShow) {
    // 页面展示时刷新页面中我的应用列表
    const emitter = getMyAppEmitter(MY_APP_EMITTER);
    emitter.emit('on-my-app-list-update');
  }
});

// 监听客户端的消息
// useRInitOnNotifyCommon()();
onBeforeUnmount(() => {
  unbindThemeChange();
  unbindPageShow();
});
</script>

<style lang="scss" scoped>
.lowcode-root {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: auto;
  overflow: overlay;
  display: flex;
  flex-direction: column;
  background-color: var(--lowcode-background-02);
}
</style>
